import { Grid } from 'src/components/Reusable/Grid'
import styled from 'styled-components/macro'
import { TextInput } from 'src/components/Reusable/Inputs'

export const ConfigureControlMappingsGrid = styled(Grid).attrs({})`
  grid-gap: 12px 20px;
  max-width: 100%;
`

export const ConfigureManualControlMappingsGrid = styled(Grid).attrs({})`
  grid-gap: 12px 20px;
  max-width: 100;
`

export const ConfigureProjectlMappingsGrid = styled(Grid).attrs({})`
  grid-gap: 12px 20px;
  max-width: 100;
`
export const ConfigureControlMappingsCheckboxContainer = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: top;
  justify-content: center;
`

export const ConfigureControlMappingsButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`

export const ConfigureReceptorFormSectionContainer = styled.div`
  width: 100%;
`
export const ConfigureReceptorFormSectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 00;
  line-height: 24px;
  margin-bottom: 8px;
`
export const ConfigureReceptorFormSectionDescription = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
`
export const MultiLineTextInput = styled(TextInput)`
  min-height: 300px;
  width: 100%;
`
